import ApiMakerBootstrapInput from "@kaspernj/api-maker-bootstrap/src/input"

export default function BootstrapInput({labelClassName, ...restProps}) {
  return (
    <ApiMakerBootstrapInput labelClassName={classNames("form-label", labelClassName)} {...restProps} />
  )
}
